<template>
	<div class="">
	  <div class="flex items-center">
	    <div class="text-gray-600 text-sm w-48">Opportunity name</div>
	    <div class="font-semibold text-sm">{{ opportunity.opportunity.opportunityName }}</div>
	  </div>

	  <div class="flex items-center pt-2 mt-2 border-t">
	    <div class="text-gray-600 text-sm w-48">Created</div>
	    <div class="font-semibold text-sm">{{ formatDate(opportunity.opportunity.createdOn, 'unix-milliseconds', 'full') }}</div>
	  </div>

	  <template v-if="opportunity.related_parties != null && opportunity.related_parties.length > 0">
	    <div class="flex items-center pt-2 mt-2 border-t">
	      <div class="text-gray-600 text-sm w-48">Applicants</div>
	      <div class="text-sm">
	        <template v-for="(applicant, index) in opportunity.related_parties">
	        	<template v-if="applicant.relationship == 'Primary Applicant' || applicant.relationship == 'Applicant'">
		          <div class="mb-1">
		            <span class="font-semibold">
		              {{ applicant.salutation }}
		              {{ applicant.fullName }}
		            </span>
		            (
		            <span class="">{{ applicant.email }}</span>
		            -
		            <span class="">{{ applicant.mobile }}</span>
		            )
		          </div>
		        </template>
	        </template>
	      </div>
	    </div>
	  </template>

	  <template v-if="opportunity.assets != null && opportunity.assets.length > 0">
	    <div class="flex items-center pt-2 mt-2 border-t">
	      <div class="text-gray-600 text-sm w-48">Assets</div>
	      <div class="text-sm">
	        <template v-for="(asset, index) in opportunity.assets">
	          <div class="mb-1" v-if="asset.type != null">
	            <span class="font-semibold">{{ asset.name }}</span>
	            -
	            <span class="font-semibold">{{ commaNumber(asset.value) }}</span>
	          </div>
	        </template>
	      </div>
	    </div>
	  </template>

	  <template v-if="opportunity.liabilities != null && opportunity.liabilities.length > 0">
	    <div class="flex items-center pt-2 mt-2 border-t">
	      <div class="text-gray-600 text-sm w-48">Liabilities</div>
	      <div class="text-sm">
	        <template v-for="(liability, index) in opportunity.liabilities">
	          <div class="mb-1" v-if="liability.type != null">
	            <span class="font-semibold">{{ liability.name }}</span>
	            -
	            <span class="font-semibold">{{ commaNumber(liability.value) }}</span>
	          </div>
	        </template>
	      </div>
	    </div>
	  </template>

	  <template v-if="opportunity.related_parties != null && opportunity.related_parties.length > 0">
	    <div class="flex items-center pt-2 mt-2 border-t">
	      <div class="text-gray-600 text-sm w-48">Third Parties</div>
	      <div class="text-sm">
	        <template v-for="(applicant, index) in opportunity.related_parties">
	        	<template v-if="applicant.relationship == 'Client Solicitor' || applicant.relationship == 'Client Accountant' || applicant.relationship == 'Client Financial Advisor'">
		          <div class="mb-1">
		            <span class="font-semibold">
		              {{ applicant.salutation }}
		              {{ applicant.fullName }}
		            </span>
		            (<span class="">{{ applicant.relationship }}</span>)
		          </div>
		        </template>
	        </template>
	      </div>
	    </div>
	  </template>
	</div>
</template>

<script>
	export default {
		props : {
			opportunity : {
				type    : Object,
				required: true
			}
		}
	}
</script>